<template>
  <v-navigation-drawer
    class="navigations"
    v-model="drawer"
    absolute
    disable-route-watcher
    hide-overlay
    touchless
    :style="{
      paddingTop: $vuetify.application.top + 'px'
    }"
  >
    <v-list dense>
      <v-list-item :to="{ name: 'analyzes' }" exact>
        <v-list-item-action>
          <v-icon>mdi-arrow-left</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ currentProject.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-treeview
      :items="groups"
      item-children="_children"
      open-all
      expand-icon="mdi-chevron-down"
      dense
      ref="tree"
      class="tree pl-3"
    >
      <template v-slot:label="{ item }">
        <router-link
          :to="{
            name: 'analysis',
            query: {
              group_id: item.id
            }
          }"
          :class="{ 'active-router': $route.query.group_id === item.id }"
          class="router"
          v-if="item._meters && item._meters.length"
        >
          {{ item.name }}
          <v-badge
            :color="$route.query.group_id === item.id ? 'primary' : 'secondary'"
            right
            class="badge"
          >
            <template v-slot:badge>
              <span>{{ item._meters.length }}</span>
            </template>
          </v-badge>
        </router-link>
        <template v-else>
          <span class="not-router">{{ item.name }}</span>
        </template>
      </template>
    </v-treeview>
  </v-navigation-drawer>
</template>

<script>
import { title } from "../mixins/title";
export default {
  name: "AnalysisGroupNavigation",
  mixins: [title],
  data: () => ({
    drawer: false,
    currentProject: {}
  }),
  computed: {
    isHaveProject: {
      get() {
        return !!(this.$route.params && this.$route.params.project);
      },
      set() {}
    },
    groups() {
      return this.$store.getters["projectMeteringStore/groupStore/getList"];
    },
    group() {
      return this.$store.getters["projectMeteringStore/groupStore/getItem"];
    }
  },
  watch: {
    "$route.params": function() {
      this.drawer = this.isHaveProject;
    },
    "$route.params.project": function() {
      this.updateList();
      this.updateCurrentProject();
    },
    drawer(val) {
      let vm = this;
      if (val !== this.isHaveProject) {
        this.$nextTick().then(() => {
          vm.drawer = vm.isHaveProject;
        });
      }
    },
    groups() {
      if (!this.$route.query.group_id) {
        let group = this.findGroupWithMeters(this.groups);
        if (group) {
          this.$router.push({
            name: "analysis",
            query: {
              group_id: group.id
            }
          });
        }
      }
      this.updateCurrentProject();
    },
    currentProject() {
      this.setTitle();
    },
    group() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("analysis.analysis"),
          this.currentProject.name,
          this.group.name
        ]
      };
    },
    updateList() {
      this.isHaveProject &&
        this.$store.dispatch("projectMeteringStore/groupStore/getList", {
          params: {
            format: "tree",
            project_id: this.$route.params.project
          }
        });
    },
    updateCurrentProject() {
      this.$nextTick().then(() => {
        this.$refs.tree && this.$refs.tree.updateAll(true);
      });
      if (!this.isHaveProject) {
        this.currentProject = {};
        return;
      }
      if (this.$route.params.project === this.currentProject.id) {
        return;
      }
      let id = this.$route.params.project;
      let list = this.$store.getters["projectStore/getList"];
      this.currentProject = list.find(item => item.id === id) || {};
    },
    findGroupWithMeters(groups) {
      let group = groups.find(i => i._meters && i._meters.length);
      if (group) {
        return group;
      } else {
        let children = groups.map(i => i._children).flat();
        if (children && children.length) {
          return this.findGroupWithMeters(children);
        }
        return undefined;
      }
    }
  },
  mounted() {
    this.updateList();
    this.drawer = this.isHaveProject;
  }
};
</script>

<style lang="scss" scoped>
.tree {
  overflow: auto;
  height: calc(100% - 64px);
  font-size: 0.8125rem;
  &::v-deep > .v-treeview-node {
    width: min-content;
    min-width: 100%;
    margin: 0;
    .v-treeview-node__label {
      overflow: visible;
      margin: 0;
    }
    .v-treeview-node__root {
      padding: 0px;
    }
  }
  &::v-deep .v-treeview-node--leaf {
    .router {
      width: 100%;
    }
    .active-router:before {
      width: 100%;
      left: 0;
    }
  }
  .badge {
    position: relative;
    transform: translate(4px, -6px) scale(0.75);
  }
}
.router {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
  min-width: calc(100% - 30px);
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  position: static;
  min-height: 40px;
  padding: 0 24px 0 14px;
}

.active-router {
  font-weight: 600;
  color: #db2828 !important;
  &:before {
    display: block;
    content: "";
    width: calc(100% + 30px);
    height: 100%;
    background: #e5e5e5;
    position: absolute;
    top: 0;
    left: -30px;
    z-index: -1;
  }
}
.not-router {
  padding: 0 14px;
}
.log {
  position: fixed;
  z-index: 9999;
  top: 40px;
}
.tree::v-deep {
  .theme--light.v-icon:focus:after {
    opacity: 0;
  }
  .v-treeview-node__toggle {
    transform: rotate(0);
    &.v-treeview-node__toggle--open {
      transform: rotate(-180deg);
    }
  }
}
</style>
